import React from 'react';
import SiteNavBar from '../navigation/SiteNavBar';
import Footer from '../footer/Footer';
import CopyRight from '../footer/CopyRight';
import './Home.css';

const Home = () => {
  return (
    // <div className="App">
    //   <SiteNavBar />
    //   <div style={{ width: '100%' }}>
    //     <div style={{ padding: '15% 0', verticalAlign: 'mid' }}>
    //       <h1 style={{ fontSize: '100px', color: '#fff', backgroundColor: 'rgb(0 0 0 / 50%)', width: '48%' }}>Farmers Marketspace</h1>
    //     </div>
    //     <div style={{ backgroundColor: '#fff', height: 'auto' }}>
    //       <h1 style={{ padding: '15px 20px 0 20px', fontSize: '50px' }}><u>Farm Fresh Benefits:</u></h1>
    //       <div style={{padding: '0 10%'}}>
    //         <div style={{ padding: '20px 50px', display: 'flex', justifyContent: 'end' }}>
    //           <div className="card">
    //             <img src={bettertaste} alt="better-taste" style={{ width: '100px', height: '100px', float: 'left', padding: '15px' }} />
    //             <div class="card-container">
    //               <h1><b>Better Taste</b></h1>
    //               <p>Higher quality products</p>
    //             </div>
    //           </div>
    //         </div>
    //         <div style={{ padding: '20px 50px', display: 'flex', justifyContent: 'start' }}>
    //           <div className="card">
    //             <img src={betterhealth} alt="better-taste" style={{ width: '100px', height: '100px', float: 'left', padding: '15px' }} />
    //             <div class="card-container">
    //               <h1><b>Better Health</b></h1>
    //               <p>Opportunity to purchase unique/specialty products</p>
    //             </div>
    //           </div>
    //         </div>
    //         <div style={{ padding: '20px 50px', display: 'flex', justifyContent: 'end' }}>
    //           <div className="card">
    //             <img src={helpingfarmers} alt="better-taste" style={{ width: '100px', height: '100px', float: 'left', padding: '15px' }} />
    //             <div class="card-container">
    //               <h1><b>Helping Farmers</b></h1>
    //               <p>Supporting local economy</p>
    //             </div>
    //           </div>
    //         </div>
    //         <div style={{ padding: '20px 50px', display: 'flex', justifyContent: 'start' }}>
    //           <div className="card">
    //             <img src={savingenvironment} alt="better-taste" style={{ width: '100px', height: '100px', float: 'left', padding: '15px' }} />
    //             <div class="card-container">
    //               <h1><b>Saving Environment</b></h1>
    //               <p>Lower carbon footprint</p>
    //             </div>
    //           </div>
    //         </div>
    //         <div style={{ padding: '20px 50px', display: 'flex', justifyContent: 'end' }}>
    //           <div className="card">
    //             <img src={transparency} alt="better-taste" style={{ width: '100px', height: '100px', float: 'left', padding: '15px' }} />
    //             <div class="card-container">
    //               <h1><b>Transparency</b></h1>
    //               <p>Knowledge of source</p>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div>
      <SiteNavBar />
      <div className="search-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <span className="close-btn"><i className="fas fa-window-close"></i></span>
              <div className="search-bar">
                <div className="search-bar-tablecell">
                  <h3>Search For:</h3>
                  <input type="text" placeholder="Keywords" />
                  <button type="submit">Search <i className="fas fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-area hero-bg home-page-hero" style={{ paddingTop: '3%' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hero-text">
                <div className="hero-text-tablecell" style={{ padding: '15% 0' }}>
                  <p className="subtitle">Farmers Marketspace</p>
                  <h1 className="home-hero-title">Your Local Market, Connected Online</h1>
                  <div className="hero-btns">
                    <a href="/shop" className="boxed-btn">Shop Now</a>
                    {/* <a href="contact.html" class="bordered-btn">Contact Us</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="list-section pt-80 pb-80">
        <div className="container">
          <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>Farm Fresh Benefits:</h3>
          <div className="row mt-5">
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="list-box d-flex align-items-center">
                <div className="list-icon">
                  <i className="fas fa-apple-alt"></i>
                </div>
                <div className="content">
                  <h3>Better Taste</h3>
                  <p>Higher quality products</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="list-box d-flex align-items-center">
                <div className="list-icon">
                  <i className="fas fa-heartbeat"></i>
                </div>
                <div className="content">
                  <h3>Better Health</h3>
                  <p>Opportunity to purchase unique/specialty products</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="list-box d-flex justify-content-start align-items-center">
                <div className="list-icon">
                  <i className="fas fa-hands-helping"></i>
                </div>
                <div className="content">
                  <h3>Helping Farmers</h3>
                  <p>Supporting local economy</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="list-box d-flex align-items-center">
                <div className="list-icon">
                  <i className="fas fa-leaf"></i>
                </div>
                <div className="content">
                  <h3>Saving Environment</h3>
                  <p>Lower carbon footprint</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
              <div className="list-box d-flex align-items-center">
                <div className="list-icon">
                  <i className="fas fa-book-open"></i>
                </div>
                <div className="content">
                  <h3>Transparency</h3>
                  <p>Knowledge of source</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <CopyRight />
    </div>
  );
};

export default Home;